// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#document-add[data-v-15aef753] p{line-height:unset!important}", ""]);
// Exports
module.exports = exports;
